import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import {
  MainTableColumn,
  MainTableColumnId,
} from '@prlw/core/monitor/types/main-table';

@Component({
  selector: 'prlw-table-manage-overlay-ui',
  templateUrl: './manage-overlay.component.html',
  styleUrls: ['./manage-overlay.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageOverlayComponent {
  @Input() public columns!: MainTableColumn<MainTableColumnId>[];
  @Output() public readonly toggleColumnVisible =
    new EventEmitter<MainTableColumnId>();
  @Output() public readonly closeOverlay = new EventEmitter<void>();

  public close(): void {
    this.closeOverlay.emit();
  }

  public toggleColumn(columnId: MainTableColumnId): void {
    this.toggleColumnVisible.emit(columnId);
  }
}
